/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reference: NonNullable<unknown> }} Bell_Object_Attribute_TaskInputs */

const en_bell_object_attribute_task = /** @type {(inputs: Bell_Object_Attribute_TaskInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Attributes · ${i?.reference}`)
};

/**
* | output |
* | --- |
* | "Attributes · {reference}" |
*
* @param {Bell_Object_Attribute_TaskInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const bell_object_attribute_task = /** @type {((inputs: Bell_Object_Attribute_TaskInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bell_Object_Attribute_TaskInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bell_object_attribute_task(inputs)
});